import { useState } from 'react'
import Seo from '../components/Seo.jsx'

/*
 * UNLISTED sponsor/deals page. Reachable only via the direct link you put in
 * emails — it is noindex (see <Seo noindex/> below), excluded from the sitemap
 * (scripts/gen-sitemap.mjs), and linked from nowhere on the site. Don't add it to
 * the nav, footer, or any sitemap.
 *
 * To manage deals: edit the DEALS array. Set `active: false` to hide one without
 * deleting it. `featured: true` gives it the highlighted ribbon.
 */
const DEALS = [
  {
    active: true,
    featured: true,
    sponsor: 'Compound Purity',
    offer: 'Buy One, Get One Free',
    detail: 'Auto-added in cart on select research peptides. Third-party tested, COA on every batch.',
    code: 'BOGO',
    url: 'https://compoundpurity.com/?utm_source=calculatemypeptides&utm_medium=email&utm_campaign=sponsors',
    ends: 'Limited time',
  },
  // Add more deals here, e.g.:
  // {
  //   active: true,
  //   sponsor: 'Sponsor Name',
  //   offer: '20% off your first order',
  //   detail: 'Short description of the offer.',
  //   code: 'SAVE20',
  //   url: 'https://sponsor.com/?utm_source=calculatemypeptides&utm_medium=email&utm_campaign=sponsors',
  //   ends: 'Ends Oct 31',
  // },
]

function DealCard({ d }) {
  const [copied, setCopied] = useState(false)
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(d.code)
      setCopied(true)
      setTimeout(() => setCopied(false), 1500)
    } catch { /* clipboard may be unavailable */ }
  }
  return (
    <div className={`card deal-card${d.featured ? ' featured' : ''}`}>
      {d.featured && <span className="deal-ribbon">Featured</span>}
      <div className="deal-top">
        <span className="deal-sponsor">{d.sponsor}</span>
        {d.ends && <span className="deal-ends">{d.ends}</span>}
      </div>
      <h2 className="deal-offer">{d.offer}</h2>
      {d.detail && <p className="deal-detail">{d.detail}</p>}
      <div className="deal-actions">
        {d.code && (
          <button type="button" className="deal-code" onClick={copy} title="Click to copy">
            <span className="deal-code-label">Code</span>
            <span className="deal-code-value">{d.code}</span>
            <span className="deal-code-copy">{copied ? '✓ Copied' : 'Copy'}</span>
          </button>
        )}
        <a className="btn btn-primary" href={d.url} target="_blank" rel="noopener noreferrer sponsored">
          Shop now →
        </a>
      </div>
    </div>
  )
}

export default function Sponsors() {
  const deals = DEALS.filter((d) => d.active)
  return (
    <main className="page">
      {/* noindex: keep this page out of search entirely */}
      <Seo
        title="Sponsor Deals | CalculateMyPeptides"
        description="Exclusive partner offers for the CalculateMyPeptides community."
        noindex
      />
      <div className="container page-narrow">
        <div style={{ marginBottom: 20 }}>
          <span className="pill blue" style={{ marginBottom: 8 }}>Exclusive</span>
          <h1 className="section-title">Sponsor Deals</h1>
          <p className="section-sub" style={{ maxWidth: '60ch' }}>
            Hand-picked offers from partners we work with. Prices and availability are set by the sponsor —
            deals can change or end at any time.
          </p>
        </div>

        {deals.length === 0 ? (
          <div className="card empty">
            <div className="emoji">🎁</div>
            <h3 style={{ marginBottom: 6 }}>No active deals right now</h3>
            <p style={{ marginBottom: 0 }}>Check back soon — new offers are added here regularly.</p>
          </div>
        ) : (
          <div className="deal-grid">
            {deals.map((d, i) => <DealCard key={i} d={d} />)}
          </div>
        )}

        <p className="muted small" style={{ marginTop: 22 }}>
          Disclosure: these are paid or affiliate partnerships — we may earn a commission on purchases made through
          these links, at no extra cost to you. Educational tool, not medical advice; always follow the guidance of a
          qualified healthcare provider.
        </p>
      </div>
    </main>
  )
}
